import React from 'react';
import cn from 'classnames';
import './RPSSwitchIcon.scss';

function RPSSwitchIcon({ className }) {
  return <span className={cn('rps-switch-icon u-els-display-inline-block u-els-margin-right', className)} />;
}

export default RPSSwitchIcon;
